/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::644815cf7a1fb3049f326b10d5722b10>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { ConfluenceDataCenterLogoCS } from './logo-cs';
export { ConfluenceDataCenterIcon } from './icon';
